export const PillarCard = ({ icon: Icon, title, body, accent = "bg-roseMilk", testId }) => (
  <div className="wit-bento-cell group h-full flex flex-col" data-testid={testId}>
    <div className={`w-12 h-12 rounded-xl ${accent} flex items-center justify-center mb-5 text-plum`}>
      {Icon ? <Icon size={20} strokeWidth={1.6} /> : null}
    </div>
    <h3 className="font-serif text-xl sm:text-2xl text-ink mb-3">{title}</h3>
    <p className="text-sm text-warmGrey leading-relaxed">{body}</p>
  </div>
);

export default PillarCard;
